/*
 * インポート、エクスポート用の便利関数
 */
// import Vue from 'vue'
const COOKIE_KEYS = {
  user: 'user_imexfld',
  group: 'group_imexfld'
}
const PRESETS = {
  user: [
    '削除フラグ',
    '使用停止フラグ',
    'ID(システムID：自動発番)',
    'ログインID',
    'パスワード',
    'ユーザーレベル',
    '名刺エクスポート可能フラグ',
    '姓',
    '名',
    '姓（よみがな）',
    '名（よみがな）',
    '会社名',
    '会社名（よみがな）',
    '部署名',
    '役職',
    '郵便番号',
    '住所1',
    '住所2',
    '会社電話',
    '部署電話',
    '内線',
    '携帯電話',
    'FAX',
    'メールアドレス',
    'URL'
  ],
  group: [
    '削除フラグ',
    'ID(システムID：自動発番)',
    '組織名',
    '企業内組織コード',
    '連絡先',
    'メモ',
    '親組織'
  ]
}

export default {
  methods: {
    _getPreset: function (funcName) {
      let tmp = PRESETS[funcName]
      let preset = []
      tmp.forEach(function (item, index) {
        preset.push({
          value: index + 1,
          name: item
        })
      })
      return preset
    },
    /*
     * 項目の順番を設定する
     */
    comSetImexfld: function (funcName, isReset) {
      let preset = this._getPreset(funcName)

      // リセット
      if (isReset) {
        return preset
      }

      // Cookieに保存されている設定を取得する
      // 取得した値を配列に分割する
      let cookieImexfld = this.getCookie(COOKIE_KEYS[funcName]).split(',')

      // 項目の順番がcookieに保存されている場合、設定を反映する
      if (!cookieImexfld) {
        return preset
      }

      // ブラウザに保存されている項目順がおかしいならリセット
      if (cookieImexfld.length !== preset.length) {
        return preset
      }

      // 分割した値を項目の順番に設定する
      let imexfld = []
      for (let i = 0, len = cookieImexfld.length; i < len; i++) {
        let value = cookieImexfld[i]
        let presetItem = preset.filter(function (item) {
          return String(item.value) === String(value)
        })[0]
        let dupCount = cookieImexfld.filter(function (item) {
          return String(item) === String(value)
        }).length

        // ブラウザに保存されている項目順がおかしいならリセット
        if (!presetItem || dupCount !== 1) {
          return preset
        }

        imexfld.push({
          value: value,
          name: presetItem.name
        })
      }

      return imexfld
    },
    /*
     * 項目の順番をCookieに保存する
     */
    comSaveCookie: function (funcName, imexfld) {
      let cookieKeyName = COOKIE_KEYS[funcName]

      let saveVals = ''

      for (let i = 0; imexfld.length > i; i++) {
        saveVals += imexfld[i].value
        if (imexfld.length !== i + 1) {
          saveVals += ','
        }
      }

      this.setCookie(cookieKeyName, saveVals)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/importExport.js